<template>
  <v-layout justify-center="" style="margin-top: 10%;">
    <v-card :elevation="20" width="500" v-bind:loading="loading">
      <v-card-text class="text-center">
        <h1 class="font-weight-light">Confirm Email</h1>
      </v-card-text>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="username"
                  type="text"
                  name="username"
                  label="Username"
                  outlined
                  autofocus
                  @keyup.enter.native="confirm"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="code"
                  :type="'text'"
                  name="confirmationCode"
                  label="Confirmation Code"
                  required
                  outlined
                  @keyup.enter.native="confirm"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <a v-on:click="resend">Resend Code</a>
                <a v-on:click="signIn">Back to Sign In</a>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            @click="confirm"
            x-large
            v-bind:loading="loading"
            >Login
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-layout>
</template>

<script>
import AuthEventBus from '../events/authEventBus'
import { Auth } from 'aws-amplify'

export default {
  name: 'ConfirmSignUp',
  props: ['confirmSignUpConfig', 'usernameAttributes'],
  data() {
    return {
      code: '',
      error: '',
      loading: false
    }
  },
  computed: {
    options() {
      const defaults = {
        username: ''
      }
      return Object.assign(defaults, this.confirmSignUpConfig || {})
    }
  },
  mounted: function() {
    if (!this.options.username) {
      return this.setError('Valid username not received.')
    }
  },
  methods: {
    confirm() {
      Auth.confirmSignUp(this.options.username, this.code)
        .then(() => {
          this.logger.info('confirmSignUp success')
          AuthEventBus.$emit('authState', 'signIn')
        })
        .catch(e => this.setError(e))
    },
    resend() {
      Auth.resendSignUp(this.options.username)
        .then(() => {
          this.logger.info('resendSignUp success')
        })
        .catch(e => this.setError(e))
    },
    signIn() {
      AuthEventBus.$emit('authState', 'signIn')
    },
    setError(e) {
      this.error = e.message
    }
  }
}
</script>
